import React, { FunctionComponent } from 'react';
import { Checkbox, CheckboxProps } from 'reakit/Checkbox';
import classnames from 'classnames';

import Checkmark from '@clearkit/icons/glyphs/Checkmark';

export interface CKCheckboxProps extends CheckboxProps {
  isDisabled?: boolean;
  className?: string;
  id: string;
  label: string | React.ReactNode;
}

export const CKCheckbox: FunctionComponent<CKCheckboxProps> = ({
  isDisabled,
  label,
  id,
  className,
  ...checkbox
}) => {
  const checkboxClass = classnames('ck-checkbox', className);

  return (
    <div className={checkboxClass}>
      <Checkbox
        disabled={isDisabled}
        id={id}
        className="ck-checkbox-input"
        {...checkbox}
      />
      <label htmlFor={id} className="ck-checkbox-label">
        <div className="ck-checkbox-box">
          <Checkmark width="14" height="14" />
        </div>
        {label && <span className="ck-checkbox-text">{label}</span>}
      </label>
    </div>
  );
};

export default CKCheckbox;
